'use client';

import { atom } from 'jotai';

export const isCalculatorLoadingAtom = atom(true);
